export enum SSOProvider {
  Google = 'Google',
  Microsoft = 'Microsoft',
  Email = 'Email',
}
